<template>
    <Box @close="cancelar(false)"
         v-if="transferencia_items">
        <template #top>
            Transferencia Items: {{ transferencia_items.tfi_codigo }}
        </template>
        <template #center>
            <div class="nj-card">
                <div class="nj-gridx">
                    <LabelGroup label="Tipo transferencia"
                                :value="transferencia_items.tfi_tipo_nombre"></LabelGroup>
                    <LabelGroup label="Orden de compra"
                                :value="transferencia_items.ord_code"
                                v-if="isOrdenCompra"></LabelGroup>
                    <LabelGroup label="Almacen origen"
                                :value="transferencia_items.alm_origen_nombre"
                                v-if="isEntreAlmacenes"></LabelGroup>
                    <LabelGroup label="Almacen destino"
                                :value="transferencia_items.alm_destino_nombre"></LabelGroup>
                    <LabelGroup label="Transferido por"
                                :value="transferencia_items.tfi_usu_registrador_nombre"></LabelGroup>
                    <LabelGroup label="Fecha envio"
                                :value="transferencia_items.tfi_fecha_registro"></LabelGroup>
                    <LabelGroup label="Fecha recepción"
                                :value="transferencia_items.tfi_fecha_ingreso"></LabelGroup>
                    <LabelGroup label="Recepcionado por"
                                :value="transferencia_items.tfi_usu_recepcionador_nombre"></LabelGroup>
                    <LabelGroup label="Orden de ingreso almacén"
                                :value="transferencia_items.tfi_codigo"></LabelGroup>
                </div>
                <br>
                <div class="fluid">
                    <InputText label="N° Guia Remisión"
                               v-model="transferencia_items.tfi_guia_remision">
                    </InputText>
                </div>
                <br>
                <b-table :data="transferencia_items.lista_transferencia_items_detalle"
                         sort-icon="arrow-up"
                         sort-icon-size="is-small">
                    <template slot-scope="props">
                        <b-table-column label="Producto"
                                        header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                        <b-table-column label="Cantidad"
                                        header-class="is-info"
                                        style="width: 100px;">{{ props.row.tid_cantidad }}</b-table-column>
                        <b-table-column label="Cantidad confirmada"
                                        header-class="is-info"
                                        style="width: 100px;">
                            <InputText v-model="props.row.tid_ingreso_cantidad"
                                       tabindex="1"></InputText>
                        </b-table-column>
                        <b-table-column label="Serie"
                                        header-class="is-info">
                            <InputText v-model="props.row.pal_numero_serie"
                                       tabindex="2"
                                       :disabled="props.row.prv_item == 0"></InputText>
                        </b-table-column>
                        <b-table-column label="Notas"
                                        header-class="is-info">
                            <InputText v-model="props.row.tid_ingreso_notas"
                                       tabindex="3"></InputText>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </template>
        <template #bottom>
            <button class="nj-button c-green"
                    @click="ingresar()"><i class="mdi mdi-content-save"></i>Registrar</button>
        </template>
    </Box>
</template>

<script>
import { ResponseStatus, TransferenciaItemsService, UsuarioService } from "../../services"
import { Data } from "../../util"
import Toast from "../../util/toast"
import { Box, InputText, LabelGroup } from "../components"
import InputForm from '../components/InputForm.vue'
export default {
    name: "TransferenciaItemsView",
    components: {
        LabelGroup,
        Box,
        InputText,
    },
    props: {
        tfi_id: {
            type: Number
        }
    },
    data() {
        return {
            transferencia_items: null,
        }
    },
    computed: {
        isOrdenCompra() {
            return this.transferencia_items.tfi_tipo == Data.tipoTransferencia.ordenCompra.tit_id
        },
        isEntreAlmacenes() {
            return this.transferencia_items.tfi_tipo == Data.tipoTransferencia.entreAlmacenes.tit_id
        },
        recepcionador() {
            return UsuarioService.getUsuario().usu_nombre_completo
        }
    },
    methods: {
        cancelar(condition) {
            this.$emit("close", condition)
        },
        obtener() {
            TransferenciaItemsService
                .obtener({
                    transferencia_items: {
                        tfi_id: this.tfi_id
                    }
                })
                .then(
                    response => {
                        this.transferencia_items = response.data
                        this.transferencia_items.tfi_usu_recepcionador = UsuarioService.getUsuario().usu_id
                        this.transferencia_items.lista_transferencia_items_detalle.forEach(item => {
                            item.tid_ingreso_cantidad = item.tid_cantidad
                        })
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
        },
        ingresar() {
            // console.info("this.transferencia_items", this.transferencia_items)
            TransferenciaItemsService
                .ingresar(this.transferencia_items)
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                        this.cancelar(true)
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
    },
    mounted() {
        this.obtener()
    }
}
</script>

<style scoped></style>